import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';

const links = [
  { label: 'O Kairós', href: '/#sobre' },
  { label: 'Depoimentos', href: '/#depoimentos' },
  { label: 'Memórias 2026', href: '/memorias' },
  { label: 'Investimento', href: '/#investimento' },
  { label: 'Dúvidas', href: '/#faq' },
  { label: 'Contato', href: '/contato' },
];

export const SiteNav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const go = (href) => {
    setOpen(false);
    if (href.startsWith('/#') && pathname === '/') {
      document.getElementById(href.slice(2))?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-obsidian/85 backdrop-blur-md border-b border-white/5" data-testid="site-nav">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src="/logo-kairos.png" alt="Kairós" className="w-10 h-10 rounded-full object-cover" />
          <span className="font-display text-xl text-white">Kairós</span>
        </Link>
        <div className="hidden md:flex items-center gap-6">
          {links.map((l) => (
            <Link key={l.href} to={l.href} onClick={() => go(l.href)} className="text-gray-400 hover:text-white transition-colors text-sm">{l.label}</Link>
          ))}
          <Link to="/minha-inscricao" className="text-gray-400 hover:text-white transition-colors text-sm">Minha Inscrição</Link>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/pre-inscricao" data-testid="nav-pre-inscricao-btn">
            <Button className="bg-kairos-orange hover:bg-kairos-orange-dark text-white rounded-full px-5 h-10 text-sm">Pré-inscrição</Button>
          </Link>
          <button className="md:hidden text-gray-300 p-2" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-mobile-toggle">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden bg-obsidian border-t border-white/5 px-4 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <Link key={l.href} to={l.href} onClick={() => go(l.href)} className="text-gray-300 text-base">{l.label}</Link>
          ))}
          <Link to="/minha-inscricao" onClick={() => setOpen(false)} className="text-gray-300 text-base">Minha Inscrição</Link>
        </div>
      )}
    </nav>
  );
};
